var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcptFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.148 3.303a.8.8 0 00-.8.8v9.4a.8.8 0 00.8.8h11.4a.8.8 0 00.8-.8v-9.4a.8.8 0 00-.8-.8h-11.4zm.767 2.465L6.07 8.539a1.4 1.4 0 001.553 0l4.157-2.771-.666-.998L6.96 7.54a.2.2 0 01-.222 0L2.58 4.77l-.665.998z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.973 14.959a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75z",
    fill: "#F74F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.373 11.196V7.844h1.2v3.352h-1.2zM11.373 13.323v-1.2h1.2v1.2h-1.2z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/rcpt-fail.a751640c.svg";
export { SvgRcptFail as ReactComponent };